


































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { userService } from "../../_services";

@Component
export default class AllievoCreate extends Vue {
  private nomeAllievo: string;
  private cognomeAllievo: string;
  private emailAllievo: string;
  private cfAllievo: string;
  private idCapResidenza: number;
  private cap: string;
  private indirizzoResidenza: string;
  private telefono: string;
  private annoScolastico: number;
  private articolazione: string;
  private classe: number;

  private comuni: any;
  private articolazioni: any;
  private anniScolastici: any;
  private listaClassi: any;

  private searchComuni: object | null;
  private isLoadingComuni: boolean;

  private nomeAllievoRules: [boolean | string];
  private cognomeAllievoRules: [boolean | string];
  private emailAllievoRules: [boolean | string];
  private cfAllievoRules: [boolean | string];
  private capRules: [boolean | string];
  private indirizzoResidenzaRules: [boolean | string];
  private telRules: [boolean | string];

  constructor() {
    super();
    this.nomeAllievo = "";
    this.cognomeAllievo = "";
    this.emailAllievo = "";
    this.cfAllievo = "";
    this.idCapResidenza = 0;
    this.cap = "";
    this.indirizzoResidenza = "";
    this.telefono = "";
    this.annoScolastico = 0;
    this.articolazione = "";
    this.classe = 0;

    this.comuni = [];
    this.articolazioni = [];
    this.anniScolastici = [];
    this.listaClassi = [];

    this.searchComuni = null;
    this.isLoadingComuni = false;

    this.nomeAllievoRules = [true];
    this.cognomeAllievoRules = [true];
    this.emailAllievoRules = [true];
    this.cfAllievoRules = [true];
    this.capRules = [true];
    this.indirizzoResidenzaRules = [true];
    this.telRules = [true];
  }

  @Watch("nomeAllievo")
  onNomeChange(value: string) {
    this.nomeAllievo = value.toUpperCase();
  }

  @Watch("cognomeAllievo")
  onCognomeChange(value: string) {
    this.cognomeAllievo = value.toUpperCase();
  }

  @Watch("cfAllievo")
  onCFChange(value: string) {
    this.cfAllievo = value.toUpperCase();
  }

  validazioneNomeAllievo() {
    var valid: boolean = false;
    if (this.nomeAllievo !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.nomeAllievo);
    }
    if (valid) {
      this.nomeAllievoRules = [true];
    } else if (this.nomeAllievo === "") {
      this.nomeAllievoRules = ["Nome allieva/o necessario"];
    } else {
      this.nomeAllievoRules = [
        "Nome allieva/o deve essere compreso tra 2 e 50 caratteri"
      ];
    }
  }

  validazioneCognomeAllievo() {
    var valid: boolean = false;
    if (this.cognomeAllievo !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cognomeAllievo);
    }
    if (valid) {
      this.cognomeAllievoRules = [true];
    } else if (this.cognomeAllievo === "") {
      this.cognomeAllievoRules = ["Cognome allieva/o necessario"];
    } else {
      this.cognomeAllievoRules = [
        "Cognome allieva/o deve essere compreso tra 2 e 50 caratteri"
      ];
    }
  }

  validazioneEmailAllievo() {
    var valid: boolean = false;
    if (this.emailAllievo !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailAllievo
      );
    }
    if (valid) {
      this.emailAllievoRules = [true];
    } else if (this.emailAllievo === "") {
      this.emailAllievoRules = ["Email allieva/o necessaria"];
    } else {
      this.emailAllievoRules = ["Formato Email non corretto"];
    }
  }

  validazioneCfAllievo() {
    var valid: boolean = false;
    if (this.cfAllievo !== "") {
      valid = /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/.test(
        this.cfAllievo
      );
    }
    if (valid) {
      this.cfAllievoRules = [true];
    } else if (this.cfAllievo === "") {
      this.cfAllievoRules = ["Codice Fiscale allieva/o necessaria"];
    } else {
      this.cfAllievoRules = ["Formato Codice Fiscale non corretto"];
    }
  }

  validazioneCap() {
    var valid: boolean = false;
    if (this.cap !== "") {
      valid = /^[0-9]{5}$/.test(this.cap);
    }
    if (valid) {
      this.capRules = [true];
    } else if (this.cap === "") {
      this.capRules = ["Cap residenza necessario"];
    } else {
      this.capRules = ["Formato Cap non corretto"];
    }
  }

  validazioneIndirizzoResidenza() {
    var valid: boolean = false;
    if (this.indirizzoResidenza !== "") {
      valid = /^[a-zA-Z00-9ìèéùòà,.'\x20/-]{2,100}$/.test(
        this.indirizzoResidenza
      );
    }
    if (valid) {
      this.indirizzoResidenzaRules = [true];
    } else if (this.indirizzoResidenza === "") {
      this.indirizzoResidenzaRules = ["Indirizzo residenza necessario"];
    } else {
      this.indirizzoResidenzaRules = [
        "Indirizzo non può avere più di 100 caratteri e non deve contenere caratteri speciali"
      ];
    }
  }

  validazioneTel() {
    var valid: boolean = false;
    if (this.telefono !== "") {
      valid = /[0-9]{8,15}$/.test(this.telefono);
    }
    if (valid) {
      this.telRules = [true];
    } else if (this.telefono === "") {
      this.telRules = ["Numero di telefono necessario"];
    } else {
      this.telRules = ["Il numero di telefono non ha un formato corretto"];
    }
  }

  loadListaClassi() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var classe = {
      idClasse: 0,
      nomeClasse: ""
    };
    this.classe = 0;
    this.listaClassi = [];
    if (this.articolazione !== "") {
      var payload = {
        idIstituto: instituteInfo.id,
        idAnnoScolastico: this.annoScolastico,
        idArticolazione: this.articolazione
      };
      data
        .dispatchClassiArticolazioneIstitutoAnno(this["$store"], payload)
        .then(response => {
          response.forEach(element => {
            classe = {
              idClasse: element.idClasse,
              nomeClasse: element.classe
            };
            this.listaClassi.push(classe);
          });
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }

  close() {
    this.nomeAllievo = "";
    this.cognomeAllievo = "";
    this.emailAllievo = "";
    this.cfAllievo = "";
    this.idCapResidenza = 0;
    this.cap = "";
    this.indirizzoResidenza = "";
    this.telefono = "";
    this.annoScolastico = 0;
    this.articolazione = "";

    this.listaClassi = [];

    this.nomeAllievoRules = [true];
    this.cognomeAllievoRules = [true];
    this.emailAllievoRules = [true];
    this.cfAllievoRules = [true];
    this.capRules = [true];
    this.indirizzoResidenzaRules = [true];
    this.telRules = [true];

    bus.$emit("closeCreateDialog");
  }

  async executeValidation() {
    this.validazioneNomeAllievo();
    this.validazioneCognomeAllievo();
    this.validazioneEmailAllievo();
    this.validazioneCfAllievo();
    this.validazioneCap();
    this.validazioneTel();
    this.validazioneIndirizzoResidenza();
  }

  save() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var allievo = {
      nomeAllievo: this.nomeAllievo,
      cognomeAllievo: this.cognomeAllievo,
      emailAllievo: this.emailAllievo,
      cfAllievo: this.cfAllievo,
      idCapResidenza: this.idCapResidenza,
      cap: this.cap,
      indirizzoResidenza: this.indirizzoResidenza,
      telefono: this.telefono,
      annoScolastico: this.annoScolastico,
      articolazione: this.articolazione,
      idClasse: this.classe,
      idIstituto: instituteInfo.id
    };
    this.executeValidation().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        user
          .dispacthCreateAllievo(this["$store"], allievo)
          .then(() => {
            bus.$emit("successfullOperation", "Allieva/o creato con successo");
            bus.$emit("loadStudentsList");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  created() {
    var articolazione = {
      idArticolazione: "",
      nomeArticolazione: ""
    };
    var instituteInfo = user.readInstituteInfo(this["$store"]);

    data
      .dispatchComuniList(this["$store"])
      .then(result => {
        var obj = {
          id: 0,
          località: "",
          idProvincia: ""
        };
        result.forEach(element => {
          if (element.id !== 0) {
            obj = {
              id: element.id,
              località: element.località,
              idProvincia: element.idProvincia
            };
            this.comuni.push(obj);
          }
        });
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      });
    data
      .dispatchArticolazioni(this["$store"], instituteInfo.id)
      .then(response => {
        response.forEach(element => {
          articolazione = {
            idArticolazione: element.idArticolazione,
            nomeArticolazione: element.nomeArticolazione
          };
          this.articolazioni.push(articolazione);
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
    data
      .dispatchAnniScolastici(this["$store"])
      .then(result => {
        result.forEach((element: any) => {
          this.anniScolastici.push({
            //@ts-ignore
            nomeAnno: element.nomeAnnoScolastico,
            //@ts-ignore
            idAnno: element.idAnnoScolastico
          });
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }
}
